import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ah-modal-container" }
const _hoisted_2 = { class: "ah-modal-inner-container" }
const _hoisted_3 = { class: "ah-modal-content" }


export default /*#__PURE__*/_defineComponent({
  __name: 'HotspotsModal',
  props: ['modalVisible'],
  emits: ['modalVisibilityUpdated'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const modalVisibilityUpdated = (event) => {
	if (event.target.classList.contains('ah-modal-overlay') || event.target.classList.contains('ah-modal-close')) {
		emit('modalVisibilityUpdated', false);
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ah-modal-overlay",
    onClick: modalVisibilityUpdated
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            onClick: modalVisibilityUpdated,
            class: "ah-modal-close"
          }, "×"),
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ]))
}
}

})